import React, { useState, useEffect } from 'react'
import { Input, Button, Space } from 'antd'
import { EditOutlined, CheckOutlined, CloseOutlined } from '@ant-design/icons'

const EditableCell = ({
  value,
  onSave,
  record,
  dataIndex,
  editingKey,
  isEditing,
  onEdit,
  onCancel,
}) => {
  const [editingValue, setEditingValue] = useState(value || '')
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setEditingValue(value || '')
  }, [value])

  const handleSave = async () => {
    if (editingValue !== value) {
      setLoading(true)
      try {
        await onSave(record.id, { [dataIndex]: editingValue })
        onCancel()
      } catch (error) {
        console.error('Error saving notes:', error)
      } finally {
        setLoading(false)
      }
    } else {
      onCancel()
    }
  }

  const handleCancel = () => {
    setEditingValue(value || '')
    onCancel()
  }

  const handleEditClick = () => {
    console.log('Edit button clicked for record:', record.id)
    onEdit(record.id)
  }

  if (isEditing) {
    return (
      <Space.Compact style={{ width: '100%' }}>
        <Input.TextArea
          value={editingValue}
          onChange={(e) => setEditingValue(e.target.value)}
          onPressEnter={handleSave}
          autoSize={{ minRows: 1, maxRows: 3 }}
          style={{ flex: 1 }}
        />
        <Button
          type="primary"
          icon={<CheckOutlined />}
          onClick={handleSave}
          loading={loading}
          size="small"
        />
        <Button icon={<CloseOutlined />} onClick={handleCancel} size="small" />
      </Space.Compact>
    )
  }

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <div style={{ flex: 1, wordBreak: 'break-word' }}>
        {value || 'No notes'}
      </div>
      <Button
        type="text"
        icon={<EditOutlined />}
        onClick={handleEditClick}
        size="small"
        style={{ marginLeft: 8 }}
      />
    </div>
  )
}

export default EditableCell
